class FavSwatches extends HTMLElement {
    constructor() {
        super();
        this.swatches = this.querySelectorAll('.color')
        this.swatches.forEach(swatch => swatch.addEventListener('click', this.click.bind(this)));
    }
    click(event) {
        event.preventDefault();
        var swatch = event.target;
        var dataTitle = swatch.getAttribute('data-title');
        var dataSku = swatch.getAttribute('data-sku');
        this.closest('.card-product').querySelectorAll('img').forEach(img => {
            img.classList.remove('active');
            img.classList.add('hide-image')
        });
        this.closest('.card-product').dataset.selected = 'true';
        var matchingImages = this.closest('.card-product').querySelectorAll('img[alt*="' + dataSku + '"]');
        matchingImages.forEach(img => {
            img.classList.remove('hide-image')
            img.classList.add('active');
        });
        if(matchingImages.length == 0){
            this.closest('.card-product').querySelectorAll('img.placeholder').forEach(img => {
                img.classList.remove('hide-image')
                img.classList.add('active');
            });
        }
        var url = swatch.dataset.url;
        var link = this.closest('.card-product').querySelector('a.product-url');
        if (link) {
            console.log(link);
            link.setAttribute("href", url);
        }
        this.swatches.forEach(swatch => swatch.classList.remove('active'));
        swatch.classList.add('active');
    }
}

customElements.define('fav-swatches', FavSwatches);

class MegaMenu extends HTMLElement {
    constructor() {
        super();
        this.items = this.querySelectorAll('.header-menu');
        this.menus = this.querySelectorAll('.header-menu-content');
        this.items.forEach((item) => {
            item.addEventListener('click', this.itemClick.bind(this));
        });
        this.menus.forEach((menu) => {
            menu.addEventListener('click', this.menuClick.bind(this));
        });
    }

    menuClick(event) {
        var clickedItem = event.target;
        if(clickedItem.classList.contains('header-menu-content')) {
            document.querySelector('body').classList.remove('desktop-menu-open');
            this.items.forEach((item) => {
                item.classList.remove('active');
            })
        }
    }

    itemClick(event) {
        var clickedItem = event.target;
        if(clickedItem.classList.contains('active')) {
            clickedItem.classList.remove('active');
            document.querySelector('body').classList.remove('desktop-menu-open');
        } else {
            clickedItem.classList.add('active');
            document.querySelector('body').classList.add('desktop-menu-open');
        }
        this.items.forEach((item) => {
            if(item != clickedItem) {
                item.classList.remove('active');
            }
        })
    }
}

customElements.define('mega-menu', MegaMenu);